import { SVGProps } from './SVGProps';

const Airplane = ({ fill = 'white', width = '28', height = '23' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 512 512" fill={fill} xmlns="http://www.w3.org/2000/svg">
      {/* <path
        d="M157.422 224.269L157.422 224.269L157.428 224.259L227.928 107.759L227.208 107.094L100.208 198.594L99.9649 198.769L100.004 199.066L112.504 293.066L112.685 294.424L113.422 293.269L157.422 224.269Z"
        fill={fill || 'white'}
        stroke="white"
      />
      <path
        d="M24.1958 171.269L13.5763 177.562L25.3575 181.249L98.8575 204.249L101.483 205.071L103.715 203.462L208.828 127.731L152.295 221.152L149.249 226.184L154.474 228.886L242.474 274.386L249.188 277.857L250.426 270.401L291.426 23.4006L293.361 11.7442L283.196 17.7685L24.1958 171.269Z"
        stroke="white"
        strokeWidth="11"
      /> */}
      {/* <path d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z" /> */}
      <path d="M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z" />
    </svg>
  );
};

export default Airplane;
